import { ChangeDetectionStrategy, Component, Input, OnChanges } from "@angular/core";
import { GridColumnDefinition } from "../../../../../shared/grid/models/grid-column-definition.model";
import { GridConfiguration } from "../../../../../shared/grid/models/grid-configuration.model";
import { ArrayHelper } from "../../../../../utilities/contracts/array-helper";
import { DATA_ALLOCATION_METRICS, DataAllocation, DataAllocationValue } from "./data-allocation.model";

@Component({
  selector: "app-data-allocation-grid",
  templateUrl: "./data-allocation-grid.component.html",
  styleUrls: ["./data-allocation-grid.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataAllocationGridComponent implements OnChanges {
  @Input() title = "";
  @Input() data: DataAllocation[] = [];

  rows: DataAllocation[] = [];

  readonly gridConfiguration = new GridConfiguration({
    columns: [
      new GridColumnDefinition({ field: "metric", header: "Metric", width: "28%", isSortableColumn: false }),
      new GridColumnDefinition({ field: "compliant", header: "Compliant", width: "18%", isSortableColumn: false }),
      new GridColumnDefinition({ field: "partialCompliant", header: "Partial Compliant", width: "18%", isSortableColumn: false }),
      new GridColumnDefinition({ field: "nonCompliant", header: "Non-Compliant", width: "18%", isSortableColumn: false }),
      new GridColumnDefinition({ field: "exclusion", header: "Exclusion", width: "18%", isSortableColumn: false }),
    ],
    hasPagination: false,
    showActionColumn: false,
    showMenu: false,
    showExportAction: false,
    showSelectionControl: false,
    showHeaderCheckbox: false,
    isStateDisabled: true,
  });

  ngOnChanges(): void {
    const metrics = ArrayHelper.isAvailable(this.data)
      ? this.data
      : DATA_ALLOCATION_METRICS.map(metric => new DataAllocation({ metric }));

    this.rows = metrics.map(row => new DataAllocation({
      metric: row.metric,
      compliant: this.formatValue(row.compliant),
      partialCompliant: this.formatValue(row.partialCompliant),
      nonCompliant: this.formatValue(row.nonCompliant),
      exclusion: this.formatValue(row.exclusion),
    }));
  }

  private formatValue(value: DataAllocationValue): DataAllocationValue {
    return value == null || value === "" ? "--" : value;
  }
}
